if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;

    const {
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;

    const {
        PanelBody,
        TextControl,
        TextareaControl,
        IconButton,
        Button,
        Notice,
    } = window.wp.components;

    const { Fragment } = window.wp.element;


    const MAX_ITEMS_NO_PARAGRAPH  = 7;
    const MAX_ITEMS_WITH_PARAGRAPH = 6;

    function maxAllowedItems(hasParagraph) {
        return hasParagraph ? MAX_ITEMS_WITH_PARAGRAPH : MAX_ITEMS_NO_PARAGRAPH;
    }


    registerBlockType('custom-gutenberg/card-cabin', {
        title: 'Card – Cabin Details',
        description: 'Card with image, title, subtitle badge, feature list (max 7) and optional paragraph.',
        icon: 'list-view',
        category: 'custom-cards',
        example: {},

        attributes: {
            image: {
                type: 'string',
                default: '',
            },
            imageAlt: {
                type: 'string',
                default: '',
            },
            subtitle: {          
                type: 'string',
                default: '',
            },
            title: {
                type: 'string',
                default: '',
            },
            items: {          
                type: 'string',
                default: '[]',
            },
            paragraph: {
                type: 'string',
                default: '',
            },
            link: {
                type: 'string',
                default: '',
            },
        },

        edit({ attributes, setAttributes }) {
            const { image, imageAlt, subtitle, title, items, paragraph, link } = attributes;

            const parsedItems = (() => { try { return JSON.parse(items); } catch(e) { return []; } })();
            const hasParagraph = paragraph.trim().length > 0;
            const maxItems = maxAllowedItems(hasParagraph);


            function setItems(arr) {
                setAttributes({ items: JSON.stringify(arr) });
            }

            function onItemChange(index, value) {
                const arr = [...parsedItems];
                arr[index] = value;
                setItems(arr);
            }

            function addItem() {
                if (parsedItems.length >= maxItems) return;
                setItems([...parsedItems, '']);
            }

            function removeItem(index) {
                const arr = parsedItems.filter((_, i) => i !== index);
                setItems(arr);
            }

            function onKeyDownItem(e, index) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    if (parsedItems.length < maxItems) {
                        const arr = [...parsedItems];
                        arr.splice(index + 1, 0, '');
                        setItems(arr);
                        setTimeout(() => {
                            const inputs = document.querySelectorAll('.cabin-card-item-input');
                            if (inputs[index + 1]) inputs[index + 1].focus();
                        }, 50);
                    }
                }
                if (e.key === 'Backspace' && parsedItems[index] === '' && parsedItems.length > 1) {
                    e.preventDefault();
                    removeItem(index);
                    setTimeout(() => {
                        const inputs = document.querySelectorAll('.cabin-card-item-input');
                        const target = inputs[Math.max(0, index - 1)];
                        if (target) target.focus();
                    }, 50);
                }
            }

            // remove styles

            const editorCardStyle = {
                display: 'grid',
                gridTemplateColumns: '2fr 3fr',
                border: '1px solid #ddd',
                overflow: 'hidden',
                background: '#fff',
                fontFamily: 'inherit',
            };

            const imgWrapStyle = {
                position: 'relative',
                minHeight: '220px',
                background: '#eee',
            };

            const subtitleBadgeStyle = {
                position: 'absolute',
                top: '14px',
                left: '0',
                background: 'rgba(20,40,80,0.82)',
                color: '#fff',
                padding: '5px 14px',
                fontSize: '12px',
                fontWeight: '600',
                letterSpacing: '0.02em',
            };

            const contentStyle = {
                padding: '24px 28px',
            };

            const titleStyle = {
                fontSize: '22px',
                fontWeight: '700',
                color: '#1a2e5a',
                marginBottom: '14px',
                marginTop: '0',
            };

            const listStyle = {
                listStyle: 'none',
                padding: '0',
                margin: '0 0 12px 0',
            };

            const liStyle = {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                marginBottom: '6px',
                fontSize: '14px',
                color: '#333',
            };

            const iconStyle = {
                color: '#B39A84',
                marginTop: '2px',
                flexShrink: '0',
            };

            return (
                <Fragment>
                    {/* ── Sidebar ── */}
                    <InspectorControls>

                        <PanelBody title="Image" initialOpen={true}>
                            <MediaUpload
                                onSelect={(media) => setAttributes({ image: media.url, imageAlt: media.alt || '' })}
                                allowedTypes={['image']}
                                value={image}
                                render={({ open }) => (
                                    <Button onClick={open} isDefault isLarge style={{ marginBottom: '8px' }}>
                                        {image ? 'Change Image' : 'Select Image'}
                                    </Button>
                                )}
                            />
                            {image && (
                                <Button
                                    isLink isDestructive
                                    onClick={() => setAttributes({ image: '', imageAlt: '' })}
                                    style={{ display: 'block', marginBottom: '8px' }}
                                >
                                    Remove Image
                                </Button>
                            )}
                            <TextControl
                                label="Alt text"
                                value={imageAlt}
                                onChange={(val) => setAttributes({ imageAlt: val })}
                            />
                        </PanelBody>

                        <PanelBody title="Content" initialOpen={true}>
                            <TextControl
                                label="Subtitle / Badge"
                                value={subtitle}
                                onChange={(val) => setAttributes({ subtitle: val })}
                                placeholder="e.g. Odmor s pogledom i balkonom"
                            />
                            <TextControl
                                label="Title"
                                value={title}
                                onChange={(val) => setAttributes({ title: val })}
                                placeholder="e.g. Kabina s pogledom"
                            />
                        </PanelBody>

                        <PanelBody title={`Feature List (${parsedItems.length}/${maxItems})`} initialOpen={true}>
                            <p style={{ fontSize: '12px', color: '#666', marginTop: 0 }}>
                                Press <strong>Enter</strong> to add a new item, <strong>Backspace</strong> on an empty item to remove it.
                                Max {MAX_ITEMS_WITH_PARAGRAPH} items when paragraph is filled, {MAX_ITEMS_NO_PARAGRAPH} without.
                            </p>
                            {parsedItems.map((item, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '6px', gap: '6px' }}>
                                    <input
                                        className="cabin-card-item-input"
                                        type="text"
                                        value={item}
                                        onChange={(e) => onItemChange(index, e.target.value)}
                                        onKeyDown={(e) => onKeyDownItem(e, index)}
                                        placeholder={`Item ${index + 1}`}
                                        style={{
                                            flex: 1,
                                            padding: '6px 8px',
                                            border: '1px solid #ccc',
                                            fontSize: '13px',
                                        }}
                                    />
                                    <Button
                                        isLink isDestructive
                                        onClick={() => removeItem(index)}
                                        style={{ padding: '0 4px', fontSize: '18px', lineHeight: 1 }}
                                        title="Remove item"
                                    >
                                        ×
                                    </Button>
                                </div>
                            ))}
                            {parsedItems.length < maxItems && (
                                <Button isPrimary onClick={addItem} style={{ marginTop: '8px' }}>
                                    + Add Item
                                </Button>
                            )}
                            {parsedItems.length >= maxItems && (
                                <Notice status="warning" isDismissible={false} style={{ marginTop: '8px' }}>
                                    Maximum {maxItems} items reached{hasParagraph ? ' (paragraph is filled)' : ''}.
                                </Notice>
                            )}
                        </PanelBody>

                        <PanelBody title="Bottom Paragraph (optional)" initialOpen={false}>
                            <p style={{ fontSize: '12px', color: '#666', marginTop: 0 }}>
                                Adding text here reduces max list items to {MAX_ITEMS_WITH_PARAGRAPH}.
                            </p>
                            <TextareaControl
                                value={paragraph}
                                onChange={(val) => {
                                    // If paragraph is added and items exceed new max, trim them
                                    const newMax = maxAllowedItems(val.trim().length > 0);
                                    const trimmed = parsedItems.slice(0, newMax);
                                    setAttributes({ paragraph: val, items: JSON.stringify(trimmed) });
                                }}
                                placeholder="Optional paragraph below the list…"
                                rows={4}
                            />
                        </PanelBody>

                        <PanelBody title="Link" initialOpen={false}>
                            <TextControl
                                label="Card URL"
                                value={link}
                                onChange={(val) => setAttributes({ link: val })}
                                placeholder="/cabins/balcony"
                            />
                        </PanelBody>

                    </InspectorControls>

                    <div style={editorCardStyle}>
                        <div style={imgWrapStyle}>
                            {image
                                ? <img src={image} alt={imageAlt} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#999', fontSize: '13px' }}>No image selected</div>
                            }
                            {subtitle && <div style={subtitleBadgeStyle}>{subtitle}</div>}
                        </div>

                        <div style={contentStyle}>
                            {title && <h4 style={titleStyle}>{title}</h4>}
                            {parsedItems.length > 0 && (
                                <ul style={listStyle}>
                                    {parsedItems.map((item, i) => (
                                        <li key={i} style={liStyle}>
                                            <span style={iconStyle}>⚙</span>
                                            <span>{item || <em style={{ color: '#bbb' }}>Empty item…</em>}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {paragraph && <p style={{ fontSize: '14px', color: '#444', margin: '10px 0 0 0' }}>{paragraph}</p>}
                        </div>
                    </div>
                </Fragment>
            );
        },

        save({ attributes }) {
            const { image, imageAlt, subtitle, title, items, paragraph, link } = attributes;

            const parsedItems = (() => { try { return JSON.parse(items); } catch(e) { return []; } })();
            const Tag = link ? 'a' : 'div';
            const linkProps = link ? { href: link } : {};

            return (
                <Tag {...linkProps} className="card card-cabin-details">
                    <div className="card-img">
                        {subtitle && <span className="card-subtitle-badge">{subtitle}</span>}
                        <img
                            className="lozad cover-image"
                            data-src={image}
                            src={image}
                            alt={imageAlt}
                        />
                    </div>
                    <div className="card-body">
                        {title && <h4 className="card-title">{title}</h4>}
                        {parsedItems.length > 0 && (
                            <ul className="card-feature-list">
                                {parsedItems.filter(i => i.trim()).map((item, index) => (
                                    <li key={index} className="card-feature-item">
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                        {paragraph && paragraph.trim() && (
                            <p className="card-paragraph">{paragraph}</p>
                        )}
                    </div>
                </Tag>
            );
        },
    });
}